import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {
  private toggleSubject = new BehaviorSubject<boolean>(false); // Stores last emitted value
  invokeToggle = this.toggleSubject.asObservable(); // Observable to listen for changes

  constructor(private router: Router) {}

  onToggle(isToggle: boolean) {
    this.toggleSubject.next(isToggle); // Emit and store toggle state
  }

  getLastToggleValue(): boolean {
    return this.toggleSubject.getValue(); // Retrieve the last known toggle state
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([uri]);
    });
  }
}